import Vue from 'vue'
import API from '../../../api/endpoints'

export default {
  getCountData (entity) {
    return Vue.http.get(API.GET_STATS_COUNT(entity))
  },
  getRecentEntities (entity) {
    return Vue.http.get(API.GET_STATS_RECENT(entity), { headers: { 'X-Lazy-Fetch': '0' } })
  }
}



// WEBPACK FOOTER //
// ./src/modules/stats/store/service.js